import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const TeamProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const TeamProfilePrimaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)] sm:w-auto",
})``;

export const TeamProfileSectionActionButton = styled.button.attrs({
  className:
    "inline-flex min-h-[40px] items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const TeamProfileGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const TeamProfileGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.9fr_1.1fr]",
})``;

export const TeamProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const TeamProfilePreviewImage = styled(FallbackImage).attrs({
  className: "mx-auto h-32 w-32 max-w-full rounded-[22px] sm:h-44 sm:w-44 sm:rounded-[24px]",
})``;

export const TeamProfileGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const TeamProfileSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const TeamProfileEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const TeamProfileTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const TeamProfileSectionSecondary = styled.div.attrs({ className: "mt-3" })``;

export const TeamProfileInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const TeamProfileThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const TeamProfileLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const TeamProfileMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const TeamProfileSectionTertiary = styled.div.attrs({ className: "mt-8" })``;

export const TeamProfileLinkForm = styled.form.attrs({
  className: "space-y-5",
})``;

export const TeamProfileLinkFormCopy = styled.div.attrs({
  className: "space-y-2",
})``;

export const TeamProfileLinkFormLabel = styled.label.attrs({
  className: "text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const TeamProfileLinkFormInput = styled.input.attrs({
  className: "brand-input",
})``;

export const TeamProfileLinkFormSelect = styled.select.attrs({
  className: "brand-input",
})``;

export const TeamProfileLinkSearchResults = styled.div.attrs({
  className:
    "overflow-hidden rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)]",
})``;

export const TeamProfileLinkSearchResultButton = styled.button.attrs({
  className:
    "flex w-full items-center justify-between gap-3 border-b border-[var(--brand-border)] px-4 py-3 text-left transition hover:bg-[rgba(240,191,86,0.06)] last:border-b-0",
})``;

export const TeamProfileLinkSearchResultText = styled.div.attrs({
  className: "min-w-0 space-y-1",
})``;

export const TeamProfileLinkBrowseToggle = styled.button.attrs({
  className:
    "inline-flex items-center justify-start text-xs font-medium text-[var(--brand-highlight)] transition hover:text-[var(--brand-ink)]",
})``;

export const TeamProfileLinkFormActions = styled.div.attrs({
  className: "flex items-center justify-end gap-3 pt-2",
})``;

